// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"1ab92067","703":"68edb7ce","787":"ee0dcc0c","880":"be157ec8"}[chunkId] + ".chunk.js";
};